const PreSaleCommPlan = () => import('@/views/main/report/preSaleCommPlan/PreSaleCommPlan.vue')
export default {
  path: '/main/report/preSaleCommPlan',
  name: 'preSaleCommPlan',
  component: PreSaleCommPlan,
  children: []
}
